import React from 'react';

interface PageLoaderProps {
  message?: string;
}

export const PageLoader: React.FC<PageLoaderProps> = ({ message = 'Loading…' }) => (
  <div className="page flex items-center justify-center">
    <div className="text-center animate-fade-in">
      <div className="spinner-lg mx-auto mb-4" role="status" aria-label={message} />
      <p className="text-gray-400 text-sm">{message}</p>
    </div>
  </div>
);

export default PageLoader;
